import { message } from 'antd'
import { createProject } from '../../../HttpRequests/projects';
import fetchProjects from '../../../Core/Services/fetchProjects';
import {getProps} from "../props";

export default (values) => async (dispatch) => {

  const data = { ...values }
  const response = await createProject({ data });
  const project = response.data.data;

  message.success('Project Created');

  // Fire-and-forget refresh; do not block navigation to project view
  try {
    dispatch(fetchProjects({ force: true, loadClientId: getProps().loadClientId }));
  } catch (e) {
    // Non-blocking refresh; ignore errors here
  }

  return project;

}
